import { fromJS } from 'immutable'

export default fromJS({
  questions: {
    noAlt: 'Teks alternatif untuk imej ini tiada',
    noAnswers: 'Tiada pilihan jawapan, sila klik seterusnya untuk meneruskan.',
    placeholder: 'Sila nyatakan...',
    pleaseSelect: 'Sila pilih…',
    rotateLandscape: 'Sila matikan Kunci Orientasi pada telefon anda dan putar ke landskap untuk meneruskan.',
    rotatePortrait: 'Putarkan telefon anda dari landskap ke potret untuk meneruskan.',
    ir: {
      selectWebCam: 'Pilih kamera web (jika tersedia) atau klik "Layari" untuk memuat naik dari peranti anda',
      uploadOnly: "Klik 'Layari' untuk memuat naik dari peranti anda",
      noWebCam: 'Tiada kamera web dikesan',
      accessCamUpload: 'AKSES KAMERA/MUAT NAIK',
      browse: 'LAYARI',
      uploadPhoto: 'Muat naik foto',
      camera: 'Kamera Web',
      instead: 'sebaliknya',
      capture: 'TANGKAP',
      somethingWrong: 'Maaf, ada sesuatu yang tidak kena. Sila cuba lagi kemudian',
      couldntRead: 'Maaf, kami tidak dapat membaca kod!',
      couldntProcess: 'Maaf, kami tidak dapat memproses imej!',
      inValidCode: 'Sila serahkan kod yang sah',
      moveOn: 'Sila cuba lagi atau serahkan foto anda dan teruskan',
      tryAgain: 'Sila cuba lagi',
      dataReceived: 'Data diterima!',
      enterManually: 'Sila cuba lagi atau masukkan data secara manual di bawah',
      positionQR:
        'Sila posisikan kod QR di depan kamera anda supaya ia muat dalam bingkai merah atau muat naik dari komputer anda.',
      positionQRMobile:
        'Sila posisikan kod QR di depan kamera anda supaya ia muat dalam bingkai merah atau muat naik dari komputer anda.',
      analyzing: 'Menganalisis imej, sila tunggu',
      submit: 'SERAH',
      startOver: 'Mulakan semula',
      allDone: 'Semua selesai!',
      cantAnalyze:
        'Perhatian - kami tidak dapat mengemas imej ini. Sila cuba menyerahkannya semula atau pilih format yang lebih generik (JPG, PNG, GIF, BMP)',
      wrongFormat:
        'Harap maaf - kami tidak menyokong format fail ini. Sila muat naik jenis imej yang disokong (JPG, PNG, GIF, BMP, TIF, PDF, SVG)'
    },
    vr: {
      noWebCam: 'Tiada kamera web dikesan',
      uploadVideo: 'Muat naik video',
      skip: 'Langkau?',
      accessCamUpload: 'AKSES KAMERA/MUAT NAIK',
      browse: 'LAYARI',
      instead: 'sebaliknya',
      or: 'atau',
      stopRecording: 'Hentikan rakaman',
      willBeStopped: 'Rakaman akan berhenti selepas 5 minit',
      stopOnDone: 'Hentikan rakaman apabila anda sudah selesai!',
      record: 'RAKAM',
      somethingWrong: 'Maaf, ada sesuatu yang tidak kena. Sila cuba lagi kemudian.',
      dataReceived: 'Data diterima!',
      microphone: 'mikrofon',
      camera: 'Kamera Web',
      selectMicrophone: 'Sila pilih mikrofon anda',
      selectCam: 'Pilih kamera web anda',
      submit: 'SERAH',
      upload: 'Muat naik',
      playback: 'Main semula',
      stopPlayback: 'HENTIKAN MAIN BALIK',
      startOver: 'Mulakan semula',
      allDone: 'Semua selesai!',
      alternativeRecordSpan: 'Sila muat naikklip video daripada peranti komputer anda. Secara alternatif, ',
      alrenativeRecordHref: 'anda boleh merakam video dengan kamera web.',
      cantAnalyze:
        'Perhatian - kami tidak dapat mengemas video ini. Sila cuba menyerahkannya semula atau pilih format video yang lebih generik (MP4, M4V, WEBPM)',
      wrongFormat:
        'Harap maaf - kami tidak menyokong format fail ini. Sila muat naik jenis video yang disokong (MP4, AVI, M4V, WEBPM, MOV, MKV, MPG, WMV)'
    },
    cjc: {
      choose: 'PILIH',
      pleaseChoose: 'Sila pilih',
      this: 'YANG',
      one: ' ini',
      myChoice: 'PILIHAN SAYA'
    },
    hm: {
      addComment: 'Sila tambah komen di bawah',
      commentMandatoryPlaceHolder: 'Sila tambah komen yang diwajibkan… ',
      commentOptionalPlaceHolder: 'Sila tambah komen pilihan…',
      dragPin: 'Seret untuk memposisikan semula (klik/ketil lama untuk mengepin dengan tepat).',
      removePin: 'Seret ke luar imej untuk memadam.',
      editComment: 'Klik/ketik pin untuk mengedit komen.',
      addPin: 'Sila seret pin dari panel di bawah dan lepaskan pin di titik pilihan anda pada imej.',
      addPins: 'Sila seret pin dari panel di bawah dan lepaskan pin di titik pilihan anda pada imej.',
      leavePins: (minPoints, maxPoints) =>
        `Sila biarkan sekurang-kurangnya ${minPoints}, tetapi tidak lebih daripada ${maxPoints} pin untuk setiap jenis.`,
      leavePinsAny: (minPoints, maxPoints) =>
        `Sila biarkan sekurang-kurangnya ${minPoints}, tetapi tidak lebih daripada ${maxPoints} pin pin daripada sebarang jenis.`,
      leavePinsPerPage: (minPoints, maxPoints) =>
        `Sila biarkan sekurang-kurangnya ${minPoints}, tetapi tidak lebih daripada ${maxPoints} pin.`,
      leavePinsWithOff: maxPoints =>
        `Sila tinggalkan tidak lebih daripada ${maxPoints} pin untuk setiap jenis atau klik Seterusnya untuk melangkau.`,
      leavePinsWithOffAny: maxPoints =>
        `Sila tinggalkan tidak lebih daripada ${maxPoints} pin daripada sebarang jenis atau klik Seterusnya untuk melangkau.`,
      leavePinsPerPageWithOff: maxPoints =>
        `Sila tinggalkan tidak lebih daripada ${maxPoints} pin atau klik Seterusnya untuk melangkau.`,
      leavePinWithOff: `Sila tinggalkan tidak lebih daripada 1 pin untuk setiap jenis atau klik Seterusnya untuk melangkau.`,
      leavePinWithOffAny: `Sila tinggalkan tidak lebih daripada 1 pin daripada sebarang jenis atau klik Seterusnya untuk melangkau.`,
      leavePinPerPageWithOff: 'Sila tinggalkan tidak lebih daripada 1 pin atau klik Seterusnya untuk melangkau.',
      leaveExactlyPin: `Sila tinggalkan 1 pin untuk setiap jenis.`,
      leaveExactlyPinAny: `Sila tinggalkan 1 pin pin daripada sebarang jenis.`,
      leaveExactlyPinPerPage: 'Sila tinggalkan 1 pin. ',
      leaveExactlyPins: maxPoints => `Sila tinggalkan ${maxPoints} pin untuk setiap jenis.`,
      leaveExactlyPinsAny: maxPoints => `Sila tinggalkan ${maxPoints} pin pin daripada sebarang jenis.`,
      leaveExactlyPinsPerPage: maxPoints => `Sila tinggalkan ${maxPoints} pin.`,
      leaveComment: 'Taip di bawah imej untuk meninggalkan komen.',
      noAnswers: 'Tiada pilihan jawapan, sila klik seterusnya untuk meneruskan.',
      outOfPins: 'Anda kehabisan pin',
      pinsBehavior:
        'Sambil anda bergerak merentasi imej, anda akan dapat melihat kawasan yang akan ditonjolkan dengan jatuhan pin tunggal.',
      clusters: 'Anda hanya boleh meletakkan pin dalam kawasan ditonjolkan ini.',
      contentAware: 'Anda boleh menjatuhkan pin di dalam atau di luar kawasan yang ditonjolkan.'
    },
    mp: {
      expand_note: 'Sila layang atas imej atau klik pada imej untuk membesarkan',
      rb_note: rows => `Sila pilih setepat-tepatnya 1 respons per item${rows ? ' di bawah' : ''}:`,
      cb_note: (min, max, rows) => {
        if (min === max) {
          return `Sila pilih ${min !== 1 ? 'mana-mana' : 'setepat-tepatnya'} ${min} respons${
            min !== 1 ? 's' : ''
          } per item${rows ? ' di bawah' : ''}:`
        } else if (min > 0 && max < 5000) {
          return `Sila pilih sekurang-kurangnya ${min} respons${
            min !== 1 ? 's' : ''
          }, tetapi tidak lebih daripada ${max} per item${rows ? ' di bawah' : ''}:`
        } else if (5000 === max && min > 0) {
          return `Sila pilih sekurang-kurangnya ${min} respons${min !== 1 ? 's' : ''} per item${
            rows ? ' di bawah' : ''
          }:`
        } else if (0 === min && max < 5000) {
          return `Sila pilih tidak lebih daripada ${max} respons${max !== 1 ? 's' : ''} per item${
            rows ? ' di bawah' : ''
          }:`
        } else {
          return 'Tandakan semua yang berkenaan:'
        }
      }
    },
    sh: {
      note: 'Klik produk untuk mengezum masuk dan menambahnya kepada troli maya anda sekiranya anda tidak membelinya di kedai',
      amazonNote:
        'Klik produk untuk mengezum masuk dan menambahnya kepada troli maya anda sekiranya anda akan membelinya secara dalam talian',
      fullCart: 'Troli anda penuh!',
      qty: 'Kuantiti',
      addToCart: 'TAMBAH KEPADA TROLI',
      deleteFromCart: 'PADAM',
      each: 'setiap satu',
      items: 'barang',
      emptyCard: 'Troli anda kosong',
      total: 'Troli',
      clearCart: 'Padam troli',
      backToStore: 'Kembali ke kedai',
      na: 'Tiada satu pun di atas',
      next: 'SETERUSNYA',
      maxCartCountError: max => `Sila tambah tidak lebih daripada ${max} produk kepada troli anda`,
      scrollError: `Sila tatal ke kiri dan kanan sepenuhnya untuk meneruskan tinjauan.`,
      maxSpentError: max => `Sila belanjakan tidak lebih daripada ${max}`,
      maxProductCountError: max =>
        `Sila tambah tidak lebih daripada kuantiti ${max} kepada troli anda untuk setiap produk.`
    },
    rb: {
      note: 'Sila pilih setepat-tepatnya 1 item:'
    },
    vo: {
      note: 'Sila tonton video sehingga tamat'
    },
    cb: {
      note: (min, max) => {
        if (1 === min && 5000 === max) {
          return 'Tandakan semua yang berkenaan:'
        } else if (min === max) {
          return `Sila pilih ${min !== 1 ? 'mana-mana' : 'setepat-tepatnya'} ${min} item${min !== 1 ? 's' : ''}:`
        } else if (min > 0 && max < 5000) {
          return `Sila pilih sekurang-kurangnya ${min} item${min !== 1 ? 's' : ''}, tetapi tidak lebih daripada ${max}:`
        } else if (5000 === max && min > 0) {
          return `Sila pilih sekurang-kurangnya ${min} item${min !== 1 ? 's' : ''}:`
        } else if (0 === min && max < 5000) {
          return `Sila pilih tidak lebih daripada ${max} item${max !== 1 ? 's' : ''}:`
        } else {
          return 'Tandakan semua yang berkenaan:'
        }
      }
    },
    oe: {
      na: 'Tidak berkaitan',
      note: (min, max, optional) => {
        if (min === max) {
          return `Sila taip ${1 !== min ? 'mana-mana' : 'setepat-tepatnya'} ${min} aksara${1 !== min ? 's' : ''}${
            optional ? ' (pilihan)' : ''
          }:`
        } else if (min > 0 && max < 5000) {
          return `Sila taip sekurang-kurangnya ${min} aksara${1 !== min ? 's' : ''} tetapi tidak lebih daripada ${max}${
            optional ? ' (pilihan)' : ''
          }:`
        } else if (5000 === max && min > 0) {
          return `Sila taip sekurang-kurangnya ${min} aksara${1 !== min ? 's' : ''}${optional ? ' (pilihan)' : ''}:`
        } else if (0 === min && max < 5000) {
          return `Sila taip tidak lebih daripada ${max} aksara${1 !== min ? 's' : ''}${optional ? ' (pilihan)' : ''}:`
        } else {
          return ''
        }
      }
    },
    oex: {
      note: 'Sila isikan medan berikut:'
    },
    mx: {
      note: 'Sila alihkan pengggelangsar yang ditonjolkan untuk meneruskan',
      dragSlider: 'Seret ke kiri atau ke kanan untuk menjawab'
    },
    psc: {
      dragLeftRight: 'Seret ke kiri atau ke kanan untuk menjawab'
    },
    ps: {
      note: (value, remaining) => `Sila edarkan ${value} ${remaining ? 'antara' : ''} item-item di bawah`,
      allDone: `Semua selesai`,
      total: `jumlah:`,
      dragSlider: 'Seret ke kiri atau ke kanan untuk menjawab'
    },
    cx: {
      note: 'Buka dropbox dan mulakan menaip jawapan anda untuk menatal secara automatik atau memilih secara manual.'
    },
    ro: {
      note: 'Seret ke atas atau ke bawah untuk menyusun semula:'
    },
    md: {
      note1:
        'Sila klik/ketik pada item pilihan  <b>pertama anda</b>.<br/> Klik/ketik sekali lagi untuk memadam pilihan.',
      note2:
        'Sekarang, sila klik/ketik item pilihan <b>terakhir anda</b>.<br/> Klik/ketik sekali lagi untuk memadam pilihan.',
      note3:
        'Terima kasih! Teruskan ke soalan seterusnya, <br/> atau klik/ketik mana-mana item yang tidak dipilih untuk bermula semula.'
    },
    aro: {
      note: 'Sila pilih satu item daripada setiap pasangan.'
    },
    wd: {
      note: 'Pastikan semua nilai seterusnya adalah lebih besar daripada yang sebelumnya.'
    },
    emd: {
      note: 'Sila tonton video sehingga tamat',
      noAnswers: 'Tiada pilihan jawapan, sila klik seterusnya untuk meneruskan.',
      start: 'Klik dan tahan untuk bermula',
      resume: 'Klik dan tahan untuk menyambung semula',
      continue: 'Anda bersedia! Klik Seterusnya untuk meneruskan',
      continueMobile: 'Anda bersedia! Klik DI SINI untuk meneruskan',
      training: {
        session: 'Sesi latihan',
        note: 'Sila tamatkan latihan',
        moveLeft: 'Sila seret dail sehingga habis <strong>ke kiri</strong>',
        moveBottom: 'Sila seret dail sehingga habis <strong>ke bawah</strong>',
        moveRight: 'Sekarang, sila seret dail sehingga habis <strong>ke kanan</strong>',
        moveTop: 'Sekarang, sila seret dail sehingga habis <strong>ke atas</strong>',
        success: 'Bagus!'
      }
    },
    sft: {
      noAnswers: 'Tiada pilihan jawapan, sila klik seterusnya untuk meneruskan.',
      note: 'Sila jawab secepat yang anda boleh dengan jawapan yang dirasakan betul',
      imageError: 'No image exposure time chosen',
      finish: 'Anda selesai! <br/> Sila klik Seterusnya untuk meneruskan',
      training: {
        start:
          '<p>Soalan ini akan menunjukkan perkataan berbeza dengan cepat kepada anda dan memerlukan penumpuan anda. ' +
          'Anda perlu bertindak balas dengan pantas untuk menjawab.  </p><p>Bersedia untuk berlatih?</p>',
        step1: (touch, mouse, key) =>
          touch
            ? `Ketik "{buttonLeft}"`
            : (mouse ? `Klik "{buttonLeft}"` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `Ketik kekunci "{keyBtnLeft}"` : ''),
        step2: (touch, mouse, key) =>
          touch
            ? `Ketik "{buttonRight}"`
            : (mouse ? `Klik "{buttonRight}"` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `Ketik kekunci "{keyBtnRight}"` : ''),
        fail: () => 'Terlalu perlahan',
        success: () => 'Bagus!',
        finish: () =>
          '<p><strong> Cemerlang!</strong></p><p>Sila pastikan penumpuan <br />' +
          'anda tidak terganggu dalam 2-3 minit seterusnya </p><p>Klik seterusnya untuk bermula apabila sudah bersedia.</p>'
      },
      buttons: {
        start: 'Mula',
        yesno: {
          left: 'Ya',
          right: 'Tidak'
        },
        matches: {
          left: 'Sepadan',
          right: 'Tidak Sepadan'
        },
        fits: {
          left: 'Muat',
          right: 'Tidak Muat'
        },
        thumbs: {
          left: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsUp"></i>',
          right: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsDown"></i>'
        },
        noyes: {
          left: 'Ya',
          right: 'Tidak'
        },
        matchesRev: {
          left: 'Sepadan',
          right: 'Tidak Sepadan'
        },
        fitsRev: {
          left: 'Muat',
          right: 'Tidak Muat'
        },
        thumbsRev: {
          left: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsUp"></i>',
          right: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsDown"></i>'
        }
      }
    }
  }
})
